// import './link.scss';

export { default } from './Link';
export { default as template } from './link.tpl';
